import { render, staticRenderFns } from "./includedClues.vue?vue&type=template&id=6f636fd6&scoped=true&lang=html&"
import script from "./includedClues.vue?vue&type=script&lang=js&"
export * from "./includedClues.vue?vue&type=script&lang=js&"
import style0 from "./includedClues.vue?vue&type=style&index=0&id=6f636fd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f636fd6",
  null
  
)

component.options.__file = "includedClues.vue"
export default component.exports